import React, { Component } from 'react'
import { Button, FormGroup, FormControl, ControlLabel } from "react-bootstrap"; 
// import logologin from '../../Comman/images/logo-new.png'
// import logologin from '../../Comman/images/logo-alecom.png'
import logologin from '../../Comman/images/alecom.png';

import loader from '../../Comman/images/loader.gif'
/*import logobackground from '../../Comman/images/loginbg.png'*/
import { Redirect,withRouter } from 'react-router-dom'
import Auth from '../../auth';
import swal from 'sweetalert';
import { withNamespaces } from 'react-i18next';
import i18n from '../../i18n';
import EngIcon from '../../Comman/images/England.png';
import SwedishIcon from '../../Comman/images/Sweden.png';
import { baseUrl } from '../../Comman/apiEndPoints';
import { Link } from 'react-router-dom';
import {QRCodeCanvas} from 'qrcode.react';
import OtpInput from 'react-otp-input';
class SuperAdminLoginComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      password: '',
      redirect: false,
      adminRadio: true,
      userRadio: false,
      redirectAdmin: false,
      redirectUser: false,
      currentScreen:'mainscreen',
      authActiveScreen:'qr',
      authActiveOtp:'',
      votp:'',
      eotp:'',
      icon:'fa fa-eye-slash icon',
    iconType:"password",
     isEye:true

    };
    this.otpforActivateApp=this.otpforActivateApp.bind(this)
    this.handleVerifyOtp=this.handleVerifyOtp.bind(this)
    this.checkAuthActiveOtp=this.checkAuthActiveOtp.bind(this)
    this.setCommonAuthenticatorMethod1=this.setCommonAuthenticatorMethod1.bind(this)
    this.checkvotp=this.checkvotp.bind(this)
        this.checkeotp=this.checkeotp.bind(this)
    this.changeScreen=this.changeScreen.bind(this)
    this.handleToggle=this.handleToggle.bind(this)

    /*this.userChange = this.userChange.bind(this)
    this.adminChange = this.adminChange.bind(this)*/
  }

  /*renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to='/registration' />
    }
  }

  renderRedirectUser = () => {
    if (this.state.redirectUser) {
      return <Redirect to='/login' />
    }
  }
  renderRedirectAdmin = () => {
    if (this.state.redirectAdmin) {
      return <Redirect to='/adminLogin' />
    }
  }*/
   componentWillReceiveProps(nextProps) {
    
      if(nextProps.currentEvent!=this.props.currentEvent){
      
         if(nextProps.currentEvent==='addauthenticator' ){
          
       this.setState({currentScreen:'addauthenticator'})
        }
         if(nextProps.currentEvent==='signInOptions' ){
          
       this.setState({currentScreen:'signInOptions'})
        }
          if(nextProps.currentEvent==='authqr' ){
          
       this.setState({currentScreen:'authqr'})
        }
          if(nextProps.currentEvent==='authnotify' ){
          
       this.setState({currentScreen:'authnotify'})
        }
          if(nextProps.currentEvent==='authotp' ){
          
       this.setState({currentScreen:'authotp'})
        }
          if(nextProps.currentEvent==='eotp' ){
          
       this.setState({currentScreen:'eotp'})
        }
      }
    }
  setRedirect = () => {
    this.setState({
      redirect: true
    })
  }
  privacyPolicy=(e)=>{
    console.log(this.props)
    this.props.history.push('/Privacy-Policy')
  }
  TermsOfUse = (e) => {
    this.props.history.push('/Terms-Of-Use')
  }
cancel = (e) => {
    this.props.history.push('/login')
  }
  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  Login = event => {
    const { t } = this.props;
    if (this.validateForm()) {
      Auth.authenticate();
      this.props.superAdminLogin(this.state.username, this.state.password);
    }
    else {
      let fields = {};
      fields["username"] = "";
      fields["password"] = "";
      this.setState({ fields: fields });
      //document.getElementById("errorMsg").innerText = "Please Enter Username & Password";
      swal({
        text: `${t('Login.Please Enter Username & Password')}`,
        icon: "error",
      });
    }
    event.preventDefault();
  }

  validateForm() {
    
    if (this.state.username.length > 0 && this.state.password.length > 0)
      return true;
    else
      return false;
  }
  changeLang(lng){
    i18n.changeLanguage(lng);
    var lang;
    if(lng == "en"){
      lang = "English";
    }
    else{
      lang = "Swedish";
    }
    this.props.setLanguage(lang);
  }
  otpforActivateApp()
  {
    this.setState({authActiveScreen:'otp'})
  }
  handleVerifyOtp = (otpCode) => {
   this.setState({authActiveOtp:otpCode})
}
 handlevotp = (otpCode) => {
   this.setState({votp:otpCode})
}
 handleeotp = (otpCode) => {
   this.setState({eotp:otpCode})
}
handleToggle  ()  {
    
    this.setState({isEye:!this.state.isEye})
   if (this.state.isEye===false){
      this.setState({icon:'fa fa-eye-slash icon'})
      this.setState({iconType:'password'})
   } else {
      this.setState({icon:'fa fa-eye icon'})
      this.setState({iconType:"text"})
   }
}
checkAuthActiveOtp()
{
  let data={
     "UserId":this.props.loginDetails.loginDetailss.UserId,
    "AuthAppId": this.props.loginDetails.authAppUser.AppUserId,
    "Code":this.state.authActiveOtp
  }
  this.props.activateAuthApp1(data)
}
checkvotp()
{
  
  let data={
     "UserId":this.props.loginDetails.loginDetailss.UserId,
   
    "MobileOTP":this.state.votp
  }
  this.props.setVerifyCode(data)
}
checkeotp()
{
  let data={
     "UserId":this.props.loginDetails.loginDetailss.UserId,
   
    "EmailSMSOTP":this.state.eotp
  }
  this.props.setVerifyEmailSMSOTP(data)
}
setCommonAuthenticatorMethod1(data1)
{
  let data={
     "UserId":this.props.loginDetails.loginDetailss.UserId,
    "MethodId": data1.AuthMethodId,
   
  }
  this.props.setCommonAuthenticatorMethod(data)
}
changeScreen(data)
{
   window.location.reload()
 // this.setState({currentScreen:data})
}
  render() {
    const { t } = this.props;
    let backgroundImage,logoImageUrl,signingtext

    console.log('kj',this.props.loginDetails)
    if(this.props.loginDetails.brandList.length !=0)
    {
 backgroundImage=baseUrl+this.props.loginDetails.brandList[0].BackGroundImage;
 logoImageUrl=baseUrl+this.props.loginDetails.brandList[0].BannerImage;
 signingtext=this.props.loginDetails.brandList[0].SigningText;
    }
    

   
    
    return (
      
        <div >
           {
            this.props.loginDetails.brandList.length !=0?  
            <div className="loginbg" style={{backgroundImage:"url(" + backgroundImage + ")",backgroundRepeat:"no-repeat",backgroundPosition:"center center",backgroundSize:"cover",backgroundAttachment:"fixed"}}>
        <div className="flag-div">
              <span onClick={() =>{this.changeLang('sv')}}>
                  <img className="flag-icon" src={SwedishIcon} alt="" title="Swedish" />
              </span>
              <span onClick={() =>{this.changeLang('en')}}>
                  <img className="flag-icon" src={EngIcon} alt="" title="English" />
              </span>
        </div>
     <div className="login-main " style={{background:"white",padding:"60px",position:"absolute",top:"50%",left:"50%",msTransform:"translateX(-50%) translateY(-50%)",WebkitTransform:"translate(-50%,-50%)",transform:"translate(-50%,-50%)",width:"50vh"}}>
          <div className="login-logo">
            <img src={logoImageUrl} alt="" />
          </div>
          
            {(() => {
              if(this.state.currentScreen==='mainscreen')
              {
  return <div className="k-form-field">
          {/* {this.props.loginDetails.loginStatus ===404  ?
                        <span className="lbl_danger"> {this.props.loginDetails.Message !== '' ? this.props.loginDetails.Message : ""}</span>
                        : <span className="lbl_success"> {this.props.loginDetails.messageLabel !== '' ? this.props.loginDetails.messageLabel : ""}</span>
                    } */}
            <form onSubmit={this.Login} >
    <div className="login-fm">
            <FormGroup controlId="username">
             
              <FormControl
                className="login-main-form-control"
                autoFocus
                type="text"
                value={this.state.username}
                onChange={this.handleChange}
                placeholder={t('Login.Enter_username')}
                autocomplete="username"
              />
            </FormGroup>
            </div>
            {/* <div className="login-fm " >
            <FormGroup controlId="password" >
             
              <FormControl
                className="login-main-form-control"
                value={this.state.password}
                onChange={this.handleChange}
                type={this.state.iconType}
                placeholder={t('Login.Enter password')}
                autocomplete="current-password" style={{ paddingRight: '30px', width: '100%' }}
              />
              <span class="input-container1" onClick={this.handleToggle}>
                 <i className={this.state.icon}></i>
              </span> 
            </FormGroup>
            </div> */}
            <div className="password-wrapper login-fm">
              <FormGroup controlId="password" >
 <FormControl controlId="password"
    className="password-input login-main-form-control"
    type={this.state.iconType}
    value={this.state.password}
    onChange={this.handleChange}
    placeholder={t('Login.Enter password')}
    autoComplete="current-password"
  />
  <i
    className={this.state.icon + " eye-icon"}
    onClick={this.handleToggle}
  ></i>
              </FormGroup>
 

  
</div>
            <div >
              <Button type="submit" className="login-button"> {t('Login.LOGIN')} </Button>
              {
                this.props.loginDetails.isLoading?  
                  <img src={loader} width="30" alt="" />:''
                }
                <br></br>
                <br></br>
                <p>
                   <a href="#">
                <span className=" login-button yellow">
                   <Link to="/forgotpassword">
                   
                  <button className="login-button signUp" style = {{fontSize : '14px', textDecoration : 'underline'}}>
                {t('Login.Forgot Password')} </button>
                </Link>
                </span></a>
                <a href="#">
                <span className=" login-button yellow"><button className="login-button signUp" onClick={this.privacyPolicy} style = {{fontSize : '14px', textDecoration : 'underline'}}>
                {t('Menu.Privacy Policy')} </button></span></a>
               </p>

               
               <p>
                <a href="#">
                <span className="login-button yellow"><button className="login-button signUp" onClick={this.TermsOfUse} style = {{fontSize : '14px', textDecoration : 'underline'}}>
                {t('Menu.Terms Of Use')} </button></span></a>
               </p>

               <p style={{color:"black !important",fontSize:"11px !important",marginTop:"0 !important"}} dangerouslySetInnerHTML={{ __html: signingtext }} ></p>
              {/* <br /><label className="label" id="errorMsg" style={{color: 'red'}}> </label> */}
            </div>
          </form>
          </div>
              }
               if(this.state.currentScreen==='addauthenticator')
              {
  return <div className="k-form-field">
           
           {(() => {
            if(this.state.authActiveScreen==='qr')
            {
             return <div>
               <h4 style={{marginBottom:'1px'}}>Scan the QR code from authenticator app to login</h4>
              <div className="login-fm" >
            <QRCodeCanvas value={this.props.loginDetails.authAppUser.Code} />,
            </div>
            <div >
              <button style={{marginTop:'1vh'}} onClick={this.otpforActivateApp} type="button" className="btn btn-primary"> Next</button>
                          <br></br>  
                          <button style={{marginTop:'1vh'}} onClick={(e)=>this.changeScreen('mainscreen')} type="button" className="btn btn-primary"> Cancel</button>

              {
                this.props.loginDetails.isLoading?  
                  <img src={loader} width="30" alt="" />:''
                }
                <br></br>
                <br></br>
                <p>
                   <a href="#">
                <span className=" login-button yellow">
                   {/* <Link to="/forgotpassword">
                   
                  <button className="login-button signUp" style = {{fontSize : '14px', textDecoration : 'underline'}}>
                Forgot Password </button>
                </Link> */}
                </span></a>
                <a href="#">
                <span className=" login-button yellow"><button className="login-button signUp" onClick={this.privacyPolicy} style = {{fontSize : '14px', textDecoration : 'underline'}}>
                {t('Menu.Privacy Policy')} </button></span></a>
               </p>

               
               <p>
                <a href="#">
                <span className="login-button yellow"><button className="login-button signUp" onClick={this.TermsOfUse} style = {{fontSize : '14px', textDecoration : 'underline'}}>
                {t('Menu.Terms Of Use')} </button></span></a>
               </p>

               <p style={{color:"black !important",fontSize:"11px !important",marginTop:"0 !important"}} dangerouslySetInnerHTML={{ __html: signingtext }} ></p>
              {/* <br /><label className="label" id="errorMsg" style={{color: 'red'}}> </label> */}
            </div>
            </div>
            }
                if(this.state.authActiveScreen==='otp')
            {
             return <div>
              <h4>Enter the OTP from authenticator app to verify Authentication.</h4>
               <div className="login-fm" style={{fontSize:'4.5vh'}}>
            <OtpInput
      value={this.state.authActiveOtp}
      onChange={this.handleVerifyOtp}
      numInputs={6}
      renderSeparator={<span>-</span>}
      inputType="tel"
      renderInput={(props) => <input {...props} />}
    />
            </div>
            <div style={{marginTop:"20px"}}>
              <button onClick={this.checkAuthActiveOtp} type="button" className="btn btn-primary"> Done</button>
                       <br></br>
                           <button style={{marginTop:'1vh'}} onClick={(e)=>this.changeScreen('mainscreen')}  type="button" className="btn btn-primary"> Cancel</button>

              {
                this.props.loginDetails.isLoading?  
                  <img src={loader} width="30" alt="" />:''
                }
                <br></br>
                <br></br>
                <p>
                   <a href="#">
                <span className=" login-button yellow">
                  {/*  <Link to="/forgotpassword">
                   
                  <button className="login-button signUp" style = {{fontSize : '14px', textDecoration : 'underline'}}>
                Forgot Password </button>
                </Link> */}
                </span></a>
                <a href="#">
                <span className=" login-button yellow"><button className="login-button signUp" onClick={this.privacyPolicy} style = {{fontSize : '14px', textDecoration : 'underline'}}>
                {t('Menu.Privacy Policy')} </button></span></a>
               </p>

               
               <p>
                <a href="#">
                <span className="login-button yellow"><button className="login-button signUp" onClick={this.TermsOfUse} style = {{fontSize : '14px', textDecoration : 'underline'}}>
                {t('Menu.Terms Of Use')} </button></span></a>
               </p>

               <p style={{color:"black !important",fontSize:"11px !important",marginTop:"0 !important"}} dangerouslySetInnerHTML={{ __html: signingtext }} ></p>
              {/* <br /><label className="label" id="errorMsg" style={{color: 'red'}}> </label> */}
            </div>
            </div>
            }

           })()}
            
          
          </div>
              }
              if(this.state.currentScreen==='signInOptions')
              {
  return <div className="k-form-field">
      <div>
               <h4>Sign In Options</h4>
              <div className="login-fm" >
           <div>
             {this.props.loginDetails.loginDetailss.Method.map((item) => (
        <div key={item.AuthMethodId}> 
         <button type="button" style={{marginBottom:"8px",backgroundColor:"blue"}}onClick={(e)=>this.setCommonAuthenticatorMethod1(item)} className="btn">{item.AuthMethod}</button>
        </div>
      ))}
           </div>
            </div>
            <div >
            <button style={{marginTop:'1vh'}} onClick={(e)=>this.changeScreen('mainscreen')}  type="button" className="btn btn-primary"> Cancel</button>

                <br></br>
                <br></br>
                <p>
                   <a href="#">
                <span className=" login-button yellow">
                   {/* <Link to="/forgotpassword">
                   
                  <button className="login-button signUp" style = {{fontSize : '14px', textDecoration : 'underline'}}>
                Forgot Password </button>
                </Link> */}
                </span></a>
                <a href="#">
                <span className=" login-button yellow"><button className="login-button signUp" onClick={this.privacyPolicy} style = {{fontSize : '14px', textDecoration : 'underline'}}>
                {t('Menu.Privacy Policy')} </button></span></a>
               </p>

               
               <p>
                <a href="#">
                <span className="login-button yellow"><button className="login-button signUp" onClick={this.TermsOfUse} style = {{fontSize : '14px', textDecoration : 'underline'}}>
                {t('Menu.Terms Of Use')} </button></span></a>
               </p>

               <p style={{color:"black !important",fontSize:"11px !important",marginTop:"0 !important"}} dangerouslySetInnerHTML={{ __html: signingtext }} ></p>
              {/* <br /><label className="label" id="errorMsg" style={{color: 'red'}}> </label> */}
            </div>
            </div>
            
          
          </div>
              }
               if(this.state.currentScreen==='authqr')
              {
  return <div className="k-form-field">
             <div>
               <h4>Scan the QR code from authenticator app to login</h4>
              <div className="login-fm" >
            <QRCodeCanvas value={this.props.loginDetails.removeAccountObject.QRCode} />,
            </div>
            <div >
              <button style={{marginTop:'1vh'}} onClick={(e)=>this.changeScreen('mainscreen')}  type="button" className="btn btn-primary"> Cancel</button>
              
                <br></br>
                <br></br>
                <p>
                   <a href="#">
                <span className=" login-button yellow">
                   {/* <Link to="/forgotpassword">
                   
                  <button className="login-button signUp" style = {{fontSize : '14px', textDecoration : 'underline'}}>
                Forgot Password </button>
                </Link> */}
                </span></a>
                <a href="#">
                <span className=" login-button yellow"><button className="login-button signUp" onClick={this.privacyPolicy} style = {{fontSize : '14px', textDecoration : 'underline'}}>
                {t('Menu.Privacy Policy')} </button></span></a>
               </p>

               
               <p>
                <a href="#">
                <span className="login-button yellow"><button className="login-button signUp" onClick={this.TermsOfUse} style = {{fontSize : '14px', textDecoration : 'underline'}}>
                {t('Menu.Terms Of Use')} </button></span></a>
               </p>

               <p style={{color:"black !important",fontSize:"11px !important",marginTop:"0 !important"}} dangerouslySetInnerHTML={{ __html: signingtext }} ></p>
              {/* <br /><label className="label" id="errorMsg" style={{color: 'red'}}> </label> */}
            </div>
            </div>
          </div>
              }
               if(this.state.currentScreen==='authotp')
              {
  return <div className="k-form-field">
             <div>
               <h4 style={{marginBottom:'1px'}}>Enter the OTP from Authenticator to login</h4>
               <div className="login-fm" style={{fontSize:'4.5vh'}}>
            <OtpInput
      value={this.state.votp}
      onChange={this.handlevotp}
      numInputs={6}
      renderSeparator={<span>-</span>}
      inputType="tel"
      renderInput={(props) => <input {...props} />}
    />
            </div>
            <div style={{marginTop:"20px"}}>
              <button style={{marginTop:'1vh'}} onClick={this.checkvotp} type="button" className="btn btn-primary"> Login</button>
          <br></br>
              <button style={{marginTop:'1vh'}} onClick={(e)=>this.changeScreen('mainscreen')}  type="button" className="btn btn-primary"> Cancel</button>
              
                <br></br>
                <br></br>
                <p>
                   <a href="#">
                <span className=" login-button yellow">
                   {/* <Link to="/forgotpassword">
                   
                  <button className="login-button signUp" style = {{fontSize : '14px', textDecoration : 'underline'}}>
                Forgot Password </button>
                </Link> */}
                </span></a>
                <a href="#">
                <span className=" login-button yellow"><button className="login-button signUp" onClick={this.privacyPolicy} style = {{fontSize : '14px', textDecoration : 'underline'}}>
                {t('Menu.Privacy Policy')} </button></span></a>
               </p>

               
               <p>
                <a href="#">
                <span className="login-button yellow"><button className="login-button signUp" onClick={this.TermsOfUse} style = {{fontSize : '14px', textDecoration : 'underline'}}>
                {t('Menu.Terms Of Use')} </button></span></a>
               </p>

               <p style={{color:"black !important",fontSize:"11px !important",marginTop:"0 !important"}} dangerouslySetInnerHTML={{ __html: signingtext }} ></p>
              {/* <br /><label className="label" id="errorMsg" style={{color: 'red'}}> </label> */}
            </div>
            </div>
          </div>
              }
                if(this.state.currentScreen==='eotp')
              {
  return <div className="k-form-field">
             <div>
               <h4 style={{marginBottom:'1px'}}>Enter the OTP from Email to login</h4>
               <div className="login-fm" style={{fontSize:'4.5vh'}}>
            <OtpInput
      value={this.state.eotp}
      onChange={this.handleeotp}
      numInputs={6}
      renderSeparator={<span>-</span>}
      inputType="tel"
      renderInput={(props) => <input {...props} />}
    />
            </div>
            <div style={{marginTop:"20px"}}>
              <button style={{marginTop:'1vh'}} onClick={this.checkeotp} type="button" className="btn btn-primary"> Login</button>
             <br></br>
              <button style={{marginTop:'1vh'}} onClick={(e)=>this.changeScreen('mainscreen')}  type="button" className="btn btn-primary"> Cancel</button>
              
                <br></br>
                <br></br>
                <p>
                   <a href="#">
                <span className=" login-button yellow">
                   {/* <Link to="/forgotpassword">
                   
                  <button className="login-button signUp" style = {{fontSize : '14px', textDecoration : 'underline'}}>
                Forgot Password </button>
                </Link> */}
                </span></a>
                <a href="#">
                <span className=" login-button yellow"><button className="login-button signUp" onClick={this.privacyPolicy} style = {{fontSize : '14px', textDecoration : 'underline'}}>
                {t('Menu.Privacy Policy')} </button></span></a>
               </p>

               
               <p>
                <a href="#">
                <span className="login-button yellow"><button className="login-button signUp" onClick={this.TermsOfUse} style = {{fontSize : '14px', textDecoration : 'underline'}}>
                {t('Menu.Terms Of Use')} </button></span></a>
               </p>

               <p style={{color:"black !important",fontSize:"11px !important",marginTop:"0 !important"}} dangerouslySetInnerHTML={{ __html: signingtext }} ></p>
              {/* <br /><label className="label" id="errorMsg" style={{color: 'red'}}> </label> */}
            </div>
            </div>
          </div>
              }
                 if(this.state.currentScreen==='authnotify')
              {
  return <div className="k-form-field">
             <div>
               <h4>Approve the request on Authenticator App to login.</h4>
               <div className="login-fm" style={{fontSize:'45px'}}>
         <i style={{fontSize:'25px'}}class="fas fa-spinner fa-spin"></i>
            </div>
            <div >
              <button style={{marginTop:'1vh'}} onClick={(e)=>this.changeScreen('mainscreen')}  type="button" className="btn btn-primary"> Cancel</button>
              
                <br></br>
                <br></br>
                <p>
                   <a href="#">
                <span className=" login-button yellow">
                   {/* <Link to="/forgotpassword">
                   
                  <button className="login-button signUp" style = {{fontSize : '14px', textDecoration : 'underline'}}>
                Forgot Password </button>
                </Link> */}
                </span></a>
                <a href="#">
                <span className=" login-button yellow"><button className="login-button signUp" onClick={this.privacyPolicy} style = {{fontSize : '14px', textDecoration : 'underline'}}>
                {t('Menu.Privacy Policy')} </button></span></a>
               </p>

               
               <p>
                <a href="#">
                <span className="login-button yellow"><button className="login-button signUp" onClick={this.TermsOfUse} style = {{fontSize : '14px', textDecoration : 'underline'}}>
                {t('Menu.Terms Of Use')} </button></span></a>
               </p>

               <p style={{color:"black !important",fontSize:"11px !important",marginTop:"0 !important"}} dangerouslySetInnerHTML={{ __html: signingtext }} ></p>
              {/* <br /><label className="label" id="errorMsg" style={{color: 'red'}}> </label> */}
            </div>
            </div>
          </div>
              }
            })()}
          
          
          
        </div>
      </div>:''
           }
          
     
      </div>
    );
  }
}

export default withNamespaces()(withRouter(SuperAdminLoginComponent))
